export class IAModal {
    ACTIVE_CLASS = 'active'
    overlayEl = '.js-ia-style-overlay';
    closeEl = '.js-ia-style-close';
    wrapperEl = '.js-ia-style';

    escPress = (e) => {
        if (e.keyCode == 27) { // escape key maps to keycode `27`
               this.onClose();
        }
    }

    onClose = () => {
        $(document).off('keyup', this.escPress);
        this.overlay.fadeOut();
        this.wrapper.fadeOut();
    }

    onOpen = () => {
        this.overlay.fadeIn();
        this.wrapper.fadeIn();
        $(document).on('keyup', this.escPress);
    }

    init = () => {
        this.overlay.on('click', this.onClose);
        this.close.on('click', this.onClose);

        this.node.on('click', this.onOpen);
    }

    constructor(node) {
        this.node = $(node);
        this.wrapper = $(this.wrapperEl);
        this.overlay = $(this.overlayEl);
        this.close = $(this.closeEl);

        this.init();
    }
}



// WEBPACK FOOTER //
// ./app/blocks/internet-acquiring-style/internet-acquiring-style.js